import { render, staticRenderFns } from "./MoreBusiness.vue?vue&type=template&id=176d68a6&scoped=true&"
import script from "./MoreBusiness.vue?vue&type=script&lang=js&"
export * from "./MoreBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MoreBusiness.vue?vue&type=style&index=0&id=176d68a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d68a6",
  null
  
)

export default component.exports